import { css } from 'styled-components';
import { FONT_BRIGHTNESS } from '../theme/constants';
export const separatorShadow = ({ theme }) => css `
  box-shadow: 0 1px 6px 0
    ${theme.themeVariables.fontBrightness === FONT_BRIGHTNESS.LIGHT
    ? 'rgba(255, 255, 255, 0.1)'
    : 'rgba(0, 0, 0, 0.1)'};
`;
//# sourceMappingURL=separatorShadow.js.map